import React, { useEffect, useState } from 'react';
import trackABTestingStep from "../../utils/trackABTestingSteps";
import trackSteps from "../../utils/trackSteps";
import useWizardStep from "../../hooks/useWizardStep";

const StepTracker: React.FC = () => {

  const wizardStep = useWizardStep();

  const [step, setStep] = useState(0);
  useEffect(() => {
    if (wizardStep != step){
      trackSteps(wizardStep);
      trackABTestingStep(wizardStep);
      setStep(wizardStep)
    }
  }, [wizardStep])
  return (null)
};
StepTracker.displayName = 'StepTracker'

export default StepTracker;